import { render, staticRenderFns } from "./specialtymange.vue?vue&type=template&id=6e5b1aeb"
import script from "./specialtymange.vue?vue&type=script&lang=js"
export * from "./specialtymange.vue?vue&type=script&lang=js"
import style0 from "./specialtymange.vue?vue&type=style&index=0&id=6e5b1aeb&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports